import { render, staticRenderFns } from "./HolidayPlusChannels.vue?vue&type=template&id=f86d3d52&scoped=true"
import script from "./HolidayPlusChannels.vue?vue&type=script&lang=js"
export * from "./HolidayPlusChannels.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusChannels.vue?vue&type=style&index=0&id=f86d3d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86d3d52",
  null
  
)

export default component.exports